// This file contains functions to convert foth and back grid and pixel coordinates.

//import { GRID_SIZE } from "./constants";

export function gridCoordsFromPosition(x, y, delta) {
  let ax = Math.round(x / delta);
  let ay = Math.round(y / delta);
  return {
    gridx: ax,
    gridy: ay
  };
}

export function positionFromGridCoords({ gridx, gridy }, delta) {
  let xn = gridx * delta;
  let yn = gridy * delta;
  return {
    x: xn,
    y: yn
  };
}

export function dimensionFromGridDimensions({ gridw, gridh }, delta) {
  let pos = positionFromGridCoords({ gridx: gridw, gridy: gridh }, delta);
  return {
    w: pos.x,
    h: pos.y
  };
}

export function coordFromGridCoord(gridcoord, delta) {
  let coord = gridcoord * delta;
  return coord;
}
